import React from "react";
import { Text } from "@fluentui/react";
import { EMPTY_RESULTS } from "../../../redux/constants/messageTypes";
import noContentIcon from "../../../assets/svg/noSearchResults.svg";

const containerStyle = {
  padding: "10px auto",
  bottom: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  minHeight: 280,
};

const messageStyle = {
  margin: "auto",
  width: "400px",
  paddingLeft: "0px",
};

const imageStyle = {
  width: 240,
  height: 240,
  objectFit: "contain",
  marginBottom: 16,
};

/**
 * @param {{ message?: string }} props
 */
export function CheckInNewListNoDataDisplay({ message }) {
  const displayMessage = message || EMPTY_RESULTS;

  return (
    <div style={containerStyle}>
      <div style={messageStyle}>
        <Text
          variant="medium"
          styles={{
            root: {
              color: "#4c8d6a",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              display: "block",
              width: "100%",
              textAlign: "center",
            },
          }}
        >
          {displayMessage}
        </Text>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            id="mainPageBackground"
            src={noContentIcon}
            style={imageStyle}
            alt="No documents"
          />
        </div>
      </div>
    </div>
  );
}
